import en from './en';
import cn from './cn';

export default {
  ENG: en,
  CHN: cn,
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js